import { ENTITY_TYPE, EntityType, MEMBERSHIP_MODE } from '../../models/entity.model';
import { isScimManagedGroupId } from '../../models/group.model';
import { TabKey, TableRow } from '../fga-table/fga-table.model';

export type GroupViewMemberFilter = (typeof GROUP_VIEW_MEMBER_FILTER)[keyof typeof GROUP_VIEW_MEMBER_FILTER];

export type GroupViewOwnerFilter = (typeof GROUP_VIEW_OWNER_FILTER)[keyof typeof GROUP_VIEW_OWNER_FILTER];

export type GroupViewTypeFilter = GroupViewMemberFilter | GroupViewOwnerFilter;

export interface GroupViewTypeFilterOption {
  label: string;
  value: GroupViewTypeFilter;
}

export interface GroupViewTabView {
  entityLabel: string;
  searchPlaceholder: string;
  typeFilterLabel: string;
  typeFilterOptions: GroupViewTypeFilterOption[];
  typeFilterTestId: string;
}

export const GROUP_VIEW_FILTER_ALL = 'all';

export const GROUP_VIEW_MEMBER_FILTER = {
  ALL: GROUP_VIEW_FILTER_ALL,
  SERVICE: ENTITY_TYPE.M2M,
  USER: ENTITY_TYPE.USER,
} as const;

export const GROUP_VIEW_OWNER_FILTER = {
  ALL: GROUP_VIEW_FILTER_ALL,
  APPLICATION_GROUP: 'application-group',
  ENTERPRISE_GROUP: 'organisation-group',
  USER: ENTITY_TYPE.USER,
} as const;

export const GROUP_VIEW_TAB_VIEWS: Record<TabKey, GroupViewTabView> = {
  [MEMBERSHIP_MODE.MEMBERS]: {
    entityLabel: 'members',
    searchPlaceholder: 'Find a member',
    typeFilterLabel: 'Member type',
    typeFilterOptions: [
      { label: 'All members', value: GROUP_VIEW_MEMBER_FILTER.ALL },
      { label: 'Users', value: GROUP_VIEW_MEMBER_FILTER.USER },
      { label: 'Services', value: GROUP_VIEW_MEMBER_FILTER.SERVICE },
    ],
    typeFilterTestId: 'group-view-member-type-filter',
  },
  [MEMBERSHIP_MODE.OWNERS]: {
    entityLabel: 'owners',
    searchPlaceholder: 'Find an owner',
    typeFilterLabel: 'Owner type',
    typeFilterOptions: [
      { label: 'All owners', value: GROUP_VIEW_OWNER_FILTER.ALL },
      { label: 'Users', value: GROUP_VIEW_OWNER_FILTER.USER },
      {
        label: 'Groups managed in this application',
        value: GROUP_VIEW_OWNER_FILTER.APPLICATION_GROUP,
      },
      {
        label: 'Groups managed by your organisation',
        value: GROUP_VIEW_OWNER_FILTER.ENTERPRISE_GROUP,
      },
    ],
    typeFilterTestId: 'group-view-owner-type-filter',
  },
};

export function matchesTypeFilter(row: TableRow, filter: GroupViewTypeFilter): boolean {
  if (filter === GROUP_VIEW_FILTER_ALL) {
    return true;
  }

  if (filter === GROUP_VIEW_OWNER_FILTER.APPLICATION_GROUP) {
    return row.type === ENTITY_TYPE.GROUP && !isScimManagedGroupId(row.id);
  }

  if (filter === GROUP_VIEW_OWNER_FILTER.ENTERPRISE_GROUP) {
    return row.type === ENTITY_TYPE.GROUP && isScimManagedGroupId(row.id);
  }

  return row.type === (filter as EntityType);
}
